export const useTouchProgress = player => {
  const state = {
    x: 0,
    y: 0,
    distX: 0,
    distY: 0
  }

  /**
   * 获取坐标
   * @param { TouchList } touchList
   */
  const getPosition = touchList => {
    const touch = touchList.item(0)
    if (touch) {
      var { clientX: x = 0, clientY: y = 0 } = touch
    }
    return {
      x,
      y
    }
  }
  /**
   * 开始滑动
   * @param { TouchEvent } evt
   */
  const onTouchStart = evt => {
    Object.assign(state, getPosition(evt.targetTouches))
  }

  /**
   * 在移动中
   * @param { TouchEvent } evt
   */
  const onTouchMove = ({ targetTouches }) => {
    var { x: distX, y: distY } = getPosition(targetTouches)
    Object.assign(state, { distX, distY })
  }

  /**
   * 结束滑动
   * @param { TouchEvent } evt 事件
   */
  const onTouchEnd = function() {
    const { distX, distY, x, y } = state
    const distance = Math.sqrt(Math.abs((distX - x) ** 2 + (distY - y) ** 2))
    const direction = distX - x > 0 ? 1 : 0
    if (direction) {
      // console.log('distance:', distance)
    } else {
      // console.log('distance:', distance)
    }
  }

  player.on('touchstart', onTouchStart)
  player.on('touchmove', onTouchMove)
  player.on('touchend', onTouchEnd)
}

export default useTouchProgress



// WEBPACK FOOTER //
// ./src/pages/lesson/play/components/aliplayer/touchProgress.js